import React, { useEffect, useState } from 'react'
import TextField from '@mui/material/TextField'
import ConfirmModal from '../../../components/ConfirmModal/ConfirmModal'
import { formatMoney } from '../../../utils/amount'
import { formatDate } from './helpers'
import ConfirmDialog from '../../../components/ConfirmDialog/ConfirmDialog'
import { useUiKit } from '../../../components/UiKit/UiKitContext'

const REASON_LIMIT = 200
export const BULK_TYPED_CHECK = 10

const SkipPaymentsModal = ({ open, rows = [], onCancel, onConfirm }) => {
  const [reason, setReason] = useState('')
  const { confirm: kitConfirm } = useUiKit()

  useEffect(() => {
    setReason('')
  }, [open])

  const count = rows.length
  const single = count === 1 ? rows[0] : null
  const total = rows.reduce((sum, row) => sum + (Number(row.amount) || 0), 0)

  if (kitConfirm) {
    return (
      <ConfirmDialog
        open={open}
        onClose={onCancel}
        title={single
          ? `Skip the ${formatMoney(single.amount)} payment for ${single.clientName || 'this client'}?`
          : `Skip ${count} payments, total ${formatMoney(total)}?`}
        impact={[
          single ? `Due ${formatDate(single.dueDate)}.` : `${count} payments leave the queue.`,
          'Skipped payments are never charged automatically until someone restores them.',
          'You can undo this from the message shown after it is done.',
        ]}
        confirmLabel={single ? 'Skip payment' : `Skip ${count} payments`}
        confirmDisabled={!reason.trim()}
        typedText={count >= BULK_TYPED_CHECK ? `${count}` : undefined}
        typedLabel={`Type ${count} to confirm how many payments you skip`}
        onConfirm={() => onConfirm(reason.trim())}
      >
        <TextField
          label="Reason (required)"
          size="small"
          fullWidth
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          inputProps={{ maxLength: REASON_LIMIT, 'data-testid': 'skip-reason-input' }}
          helperText={`${reason.length}/${REASON_LIMIT}`}
        />
      </ConfirmDialog>
    )
  }

  return (
    <ConfirmModal
      open={open}
      title={single ? 'Skip payment' : `Skip ${count} payments`}
      modalButtonTitle="Skip"
      modalWidth="hidden"
      disabled={!reason.trim()}
      setOpen={() => {}}
      onClose={onCancel}
      functionButton={() => onConfirm(reason.trim())}
    >
      <div className="flex flex-col gap-4" data-testid="skip-payments-modal">
        <p className="text-sm">
          Skipped payments leave the queue and are never charged automatically until someone restores them.
        </p>
        {single ? (
          <div className="rounded-xl border border-divider p-3 flex flex-col gap-1">
            <span className="text-sm font-medium text-text-primary">{single.clientName || 'No client record'}</span>
            <span className="text-sm text-text-primary">{formatMoney(single.amount)}</span>
            <span className="text-xs text-text-secondary">{`Due ${formatDate(single.dueDate)}`}</span>
          </div>
        ) : (
          <p className="text-sm font-medium text-text-primary">{`${count} payments, total ${formatMoney(total)}`}</p>
        )}
        <TextField
          label="Reason (required)"
          size="small"
          fullWidth
          autoFocus
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          inputProps={{ maxLength: REASON_LIMIT, 'data-testid': 'skip-reason-input' }}
          helperText={`${reason.length}/${REASON_LIMIT}`}
        />
      </div>
    </ConfirmModal>
  )
}

export default SkipPaymentsModal
